import { render, staticRenderFns } from "./CiAccommodation.vue?vue&type=template&id=a4789b3a&scoped=true"
import script from "./CiAccommodation.vue?vue&type=script&lang=js"
export * from "./CiAccommodation.vue?vue&type=script&lang=js"
import style0 from "./CiAccommodation.vue?vue&type=style&index=0&id=a4789b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4789b3a",
  null
  
)

export default component.exports